import { render, staticRenderFns } from "./MailTemplateTypeItem.vue?vue&type=template&id=8d3f594c"
import script from "./MailTemplateTypeItem.vue?vue&type=script&lang=js"
export * from "./MailTemplateTypeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports